import { utility } from "./utility.js";
//const apiKey = "e57b79494a9f1a109d1d96e3ebba1b4e";
//const baseUrl = "https://ensurebroker.servicecenterdanmark.dk/api/1.1/obj/";

//Test API
const apiKey = "e57b79494a9f1a109d1d96e3ebba1b4e";
const baseUrl =
  "https://ensurebroker.servicecenterdanmark.dk/version-test/api/1.1/obj/";

//Live API
//const apiKey ="e57b79494a9f1a109d1d96e3ebba1b4e";
//const baseUrl = "https://ensurebroker.servicecenterdanmark.dk/api/1.1/obj/";
export class BubbleClient {
  // ------------------------
  // Fetch all records
  // ------------------------
  async getAllRecords(tableName, limit = 100) {
    const all = [];
    let cursor = 0;

    while (true) {
      const res = await fetch(
        `${baseUrl}${tableName}?cursor=${cursor}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${apiKey}` },
        }
      );
      const data = await res.json();

      if (data.response?.results?.length > 0) {
        all.push(...data.response.results);
        cursor += data.response.results.length;
      }

      if (data.response?.remaining <= 0) break;
    }
    return all;
  }

  // ------------------------
  // Fetch records by filter
  // ------------------------
  async getAllBubbleRecordsByFilter(
    tableName,
    constraints,
    fields = [],
    limit = 100
  ) {
    const all = [];
    let cursor = 0;

    while (true) {
      const encoded = encodeURIComponent(constraints);
      const url = `${baseUrl}${tableName}?constraints=${encoded}&cursor=${cursor}&limit=${limit}`;
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${apiKey}` },
      });
      const data = await res.json();

      if (data.response?.results?.length > 0) {
        all.push(...data.response.results);
        cursor += data.response.results.length;
      }

      if (data.response?.remaining <= 0) break;
    }
    return all;
  }

  // ------------------------
  // Key-value pairs helper
  // ------------------------
  async bubbleKeyValuePairs(tableName, valMember = "Name") {
    const pairs = [];
    const records = await this.getAllRecords(tableName);

    for (const r of records) {
      if (!r) continue;
      const fullName =
        r[valMember] ||
        r.fields?.[valMember] ||
        r[valMember.toLowerCase()] ||
        "";
      pairs.push({ key: r._id || r.id, value: fullName });
    }
    return pairs;
  }

  // ------------------------
  // Create new record
  // ------------------------
  async createBubbleRecord(tableName, fields) {
    let url = `${baseUrl}${tableName}`;
    const isEmail = tableName.toLowerCase() === "email";

    if (isEmail) {
      // Use Workflow API for emails instead of Data API
      url = baseUrl.replace("/obj/", "/wf/archive-email");
    }

    console.log(`[Bubble API] Creating record in ${tableName} at ${url}:`, fields);

    const res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(fields),
    });

    const data = await res.json();
    if (!res.ok) {
      console.error(`[Bubble API Error] Failed to create record in ${tableName}:`, {
        status: res.status,
        statusText: res.statusText,
        error: data,
      });
      return { record: data, success: false };
    }

    // Workflow API returns { response: { id: "..." } }
    // Data API returns { response: { id: "..." } } or similar
    let recordId = data.response?.id || data.id;
    return { record: { id: recordId, ...data }, success: true };
  }

  // ------------------------
  // Update existing record
  // ------------------------
  async updateBubbleRecord(tableName, fields, recordId) {
    const url = `${baseUrl}${encodeURIComponent(tableName)}/${recordId}`;
    const res = await fetch(url, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(fields),
    });

    const data = await res.json();
    return { record: data, success: res.ok };
  }

  // ------------------------
  // Check if email already exists
  // ------------------------
  async isEmailExist(tableName, mailItem) {
    if (!mailItem) return false;
    const mailKey = utility.getMailUniqueKey(mailItem);
    const constraints = JSON.stringify([
      { key: "Mail unique key", constraint_type: "equals", value: mailKey },
    ]);

    const records = await this.getAllBubbleRecordsByFilter(
      tableName,
      constraints
    );
    return records?.length > 0;
  }

  // ------------------------
  // Get full email record if it exists
  // ------------------------
  async getEmailRecord(tableName, mailItem) {
    if (!mailItem) return null;
    const mailKey = utility.getMailUniqueKey(mailItem);
    const constraints = JSON.stringify([
      { key: "Mail unique key", constraint_type: "equals", value: mailKey },
    ]);

    const records = await this.getAllBubbleRecordsByFilter(
      tableName,
      constraints
    );
    return records?.length > 0 ? records[0] : null;
  }
}
